import Skeleton from '@mui/material/Skeleton';

import {
  CardContentStyled,
  StyledCard,
  StyledCardHeader,
} from './OrderConversionListConversionChart.styled';

export const OrderConversionListConversionChartSkeleton: React.FC = () => (
  <StyledCard>
    <StyledCardHeader title={<Skeleton variant="text" width={140} />} titleSize="smallBold" />
    <CardContentStyled>
      <Skeleton height="100%" variant="rectangular" width="100%" />
    </CardContentStyled>
  </StyledCard>
);
